import React from "react";
import PropTypes from "prop-types";

const StepComponent = (props) => {
  if (!props.process) return null;

  const max = props.process.getMaximumStepsCount(props.data);
  const current = props.process.getPassedStepsCount(props.data);
  const width = props.ended ? '100%' : `${(current / max) * 100}%`;
  console.log('StepComponent', props, max, current, width);
  return (
    <div className='step-progress'>
      <div style={{width}} />
    </div>
  );
}

StepComponent.propTypes = {
  process: PropTypes.object,
  data: PropTypes.object,
  ended: PropTypes.bool,
}

export default StepComponent;